import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { usePortfolioStore } from "../../stores/portfolioStore";

const BackToTopBtn: React.FC = () => {
  const { showBackToTop } = usePortfolioStore();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!showBackToTop) return null;

  return (
    <button
      className="back_to_top bounce group relative overflow-hidden whitespace-nowrap transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_8px_rgba(55,216,184,0.4)] flex justify-center items-center"
      onClick={scrollToTop}
      style={
        {
          // Override default background to allow gradient border to show
          backgroundColor: "transparent",
          // Laser border CSS variables
          "--spread": "90deg",
          "--shimmer-color": "#37d8b8",
          "--speed": "1.5s",
          "--radius": "50%",
          "--cut": "3px", // Border thickness
          "--bg": "radial-gradient(circle at center, #1e293b, #0f172a)",
        } as React.CSSProperties
      }
    >
      <div className="absolute inset-0 overflow-hidden rounded-full">
        <div className="absolute inset-[-100%] rotate-gradient">
          <div className="absolute inset-0 [background:conic-gradient(from_calc(270deg-(var(--spread)*0.5)),transparent_0,var(--shimmer-color)_var(--spread),transparent_var(--spread))]"></div>
        </div>
      </div>
      {/* Inner background circle */}
      <div className="absolute [background:var(--bg)] [border-radius:var(--radius)] [inset:var(--cut)] z-0"></div>

      {/* Icon */}
      <div className="relative z-10 text-[#37d8b8] flex items-center justify-center">
        <FontAwesomeIcon icon={faCaretUp} />
      </div>
    </button>
  );
};

export default BackToTopBtn;
